export const environment = {
  production: false,
  apiUrl: 'https://api.tubify.eu',
  apiUrl_: 'http://localhost:3000',
  adPlaceholderFolder: '/assets/ads'
};
